(function () {
  const el = document.getElementById("line-popup");
  if (!el) return;

  const delaySec = Number(el.getAttribute("data-delay-sec") || "10");
  const cooldownHours = Number(el.getAttribute("data-cooldown-hours") || "24");
  const lockMode = el.getAttribute("data-lock-mode") || "rolling_24h"; // rolling_24h | calendar_day_jst

  const KEY = "lp_last_shown_key";

  const now = () => Date.now();
  const hours = (ms) => ms / 1000 / 60 / 60;

  function jstDateKey() {
    // JST基準で YYYY-MM-DD を作る
    const d = new Date();
    const utc = d.getTime() + d.getTimezoneOffset() * 60000;
    const jst = new Date(utc + 9 * 60 * 60000);
    const y = jst.getFullYear();
    const m = String(jst.getMonth() + 1).padStart(2, "0");
    const day = String(jst.getDate()).padStart(2, "0");
    return `jst_${y}-${m}-${day}`;
  }

  function canShow() {
    const stored = localStorage.getItem(KEY);
    if (!stored) return true;

    if (lockMode === "calendar_day_jst") {
      // 同日ならNG
      return stored !== jstDateKey();
    }

    // rolling_24h: 前回表示から cooldownHours 経過ならOK
    const last = Number(stored || 0);
    if (!last) return true;
    return hours(now() - last) >= cooldownHours;
  }

  function markShown() {
    if (lockMode === "calendar_day_jst") {
      localStorage.setItem(KEY, jstDateKey());
    } else {
      localStorage.setItem(KEY, String(now()));
    }
  }

  function open() {
    el.classList.add("is-open");
    el.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    // 表示した時点でロック（閉じても当日は再表示しない）
    markShown();
  }

  function close() {
    el.classList.remove("is-open");
    el.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  // close handlers
  el.querySelectorAll("[data-lp-close]").forEach((btn) => {
    btn.addEventListener("click", close);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && el.classList.contains("is-open")) close();
  });

  // show trigger
  if (canShow()) {
    window.setTimeout(open, Math.max(0, delaySec) * 1000);
  }

  // CTA click hook（必要ならGA4/Metaに合わせて差し替え）
  const cta = document.getElementById("lp-line-cta");
  if (cta) {
    cta.addEventListener("click", () => {
      // window.dataLayer?.push({ event: "line_popup_cta_click" });
      // gtag?.("event", "line_popup_cta_click");
    });
  }
})();
